import { makeRule } from '@core/utils/rule.js'

export let searchRules = {}

export let formRules = {
  name: [
    {...makeRule('请输入回款名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  customerid: [
    {...makeRule('请选择客户名称', 'integer')},
  ],
  type: [
    {...makeRule('请选择回款类型', 'integer')},
  ],
  receipt_info_id: [
    {...makeRule('请选择客户名称', 'integer')},
  ],
  desc: [
    {...makeRule('请输入回款描述', 'string')},
  ],
  our_company_id: [
    {...makeRule('请选择收款公司', 'integer')},
  ],
  our_company_account_id: [
    {...makeRule('请选择收款账户', 'integer')},
  ],
  collection_amount: [
    {...makeRule('请输入回款金额', 'string')},
  ],
  received_date: [
    {...makeRule('请选择回款日期', 'string')},
  ],
  // mail_to: [
  //   {...makeRule('请选择收件人', 'array')},
  // ],
  // memo: [
  //   {...makeRule('请输入回款备注', 'string')},
  // ],
  attached_file: [
    {...makeRule('请上传附件', 'array')},
  ],
}

export let forceFinishRules = {
  reason: [
    {required: true, message: '核销说明不能为空', trigger: 'blur'},
  ],
}



// WEBPACK FOOTER //
// ./src/views/received-payment/received-payment.rules.js